import restApi from '@/utils/rest-api'

export default {
    getCommercialBanners: () => {
        return restApi.get('commercial-banners/available')
    }
}
